import React from 'react'
import PropTypes from 'prop-types'
import Page from 'components/Page'
import FreeReign from './FreeReign'
import OnePageFunnel from './OnePageFunnel'

const LandingView = (props) => {
  const { landingType, ...restProps } = props
  let view

  if (landingType === 'free-reign') {
    view = <FreeReign id="landingPage" {...restProps} />
    return view
  }

  if (landingType === 'one-page-funnel') {
    view = <OnePageFunnel {...restProps} />
  }

  return (
    <Page id="landingPage">
      <Page.Section>{view}</Page.Section>
    </Page>
  )
}

LandingView.propTypes = {
  slug: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
  title: PropTypes.string,
  header: PropTypes.string,
  video: PropTypes.string,
  landingUrl: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  thumbnail: PropTypes.string,
  shortDescription: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  landingType: PropTypes.string.isRequired,
  bonus1: PropTypes.any,
  bonus2: PropTypes.any,
  bonus3: PropTypes.any,
  ending: PropTypes.any,
}

export default LandingView



// WEBPACK FOOTER //
// ./src/components/Landing/index.js